import type { BaseMediaObject } from 'services/assist-api/entities/media-object/types';

export type BaseTestInstanceResponse = API_JSON & AssessmentResponse;

export enum TestInstanceResponseInputType {
  Manual = 'manual',
  Online = 'online',
  Media = 'media',
  Ai = 'ai'
}

// GET types:

export type ResponseItem = API_JSON & {
  comment: string | null;
  inputType: TestInstanceResponseInputType;
  isCorrect: boolean;
  submittedOptions: API_JSON;
  submittedValue: string;
  testItem: API_JSON;
};
export type TestInstanceResponseWithResponseItemsAndMediaObjects = BaseTestInstanceResponse & {
  responseItems: ResponseItem[];
  mediaObjects?: BaseMediaObject[];
};

export type TestInstanceResponseWithUserAndTestInstance = BaseTestInstanceResponse & {
  user: {
    id: number;
    level: { id: number };
    referenceLevel: { id: number };
  };
  testInstance: {
    area: { id: number };
    test: { id: number };
  };
};

export type BaseTestInstanceResponseItem = {
  submittedOptions: string[] | undefined;
  submittedValue: string;
  isCorrect?: boolean | undefined;
  testItem: string;
};

// POST/PATCH types:
export type PostAssessmentResponseData = BaseTestInstanceResponse & {
  testInstanceResponseItems: BaseTestInstanceResponseItem[];
};

export type AssessmentResponse = {
  status: ResponseStatus;
  logitScore: number;
  scaleScore: number;
  scaleError: number;
  rawScore: number;
  numberOfItems: number;
  stanine: number;
  stage: string;
  token: Token;
  testInstance: API_JSON;
  user: API_JSON; // This is the UsersTestInstances relation, not the CustomerUser or User.
};

export type Token = { id: number; name: string; value: string };
export enum ResponseStatus {
  REGISTERED = 'registered',
  READY = 'ready',
  STARTED = 'started',
  FINISHED = 'finished',
  CLOSED = 'closed'
}

export type PostAssessmentResponse = Pick<BaseTestInstanceResponse, 'status'> & {
  testInstance: number;
  token: number;
  user?: number;
  testInstanceResponseItems: BaseTestInstanceResponseItem[];
  session: string;
};

export type PostTestInstanceResponse = Pick<BaseTestInstanceResponse, 'status'> & {
  session: string;
  testInstance: number;
  token: number;
  user?: number;
};
